<template>
    <div v-if="newsList.length" class="hk-news">
        <h4 class="title">活动资讯</h4>
        <ul class="news-container">
            <li
                v-for="(item, index) in newsList"
                :key="item.id"
                class="news-item flex flex-between flex-start"
            >
                <p class="serial-number">{{ index + 1 >= 10 ? index : '0' + (index + 1) }}</p>
                <a target="_blank" :href="item.link" class="news-title">{{ item.title }}</a>
            </li>
        </ul>
    </div>
</template>

<script>
import { queryOpenCourseNews } from '@api/homepage';
export default {
    data() {
        return {
            newsList: []
        };
    },
    created() {
        this.getNews();
    },
    methods: {
        async getNews() {
            const data = await queryOpenCourseNews();
            this.newsList = data.data;
        }
    }
};
</script>
<style lang="scss" scoped>
.hk-news {
    box-sizing: border-box;
    width: 290px;
    background: #ffffff;
    border-radius: 4px;
    padding: 30px 18px 42px;
    margin-left: 20px;
    .title {
        font-size: 20px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #322d33;
        margin-bottom: 18px;
    }
    .news-item:not(:first-child) {
        margin-top: 40px;
    }
    .serial-number {
        font-size: 26px;
        font-family: FZLANTY_DAK;
        font-weight: normal;
        color: #d2d0d2;
        margin-right: 22px;
    }
    .news-title {
        font-size: 14px;
        font-family: PingFang;
        font-weight: bold;
        color: #322d33;
        line-height: 24px;
        text-decoration: none;
    }
}
</style>
